/** Color predominante del logo en PDF / vista previa */
export const LOGO_TONE = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const LOGO_TONE_OPTIONS = [
  {
    value: LOGO_TONE.LIGHT,
    label: 'Claro (blanco, crema, colores pastel)',
    hint: 'Usamos fondo azul oscuro en el PDF para que se lea bien.',
  },
  {
    value: LOGO_TONE.DARK,
    label: 'Oscuro (negro, gris, azul muy oscuro)',
    hint: 'Sin fondo azul: el logo va sobre blanco o gris muy claro.',
  },
];

export function normalizeLogoTone(value) {
  const v = String(value || '').trim().toLowerCase();
  if (v === LOGO_TONE.DARK) return LOGO_TONE.DARK;
  return LOGO_TONE.LIGHT;
}

/** true = marco azul oscuro Contsuite (logos con elementos claros) */
export function preferDarkLogoFrame(logoTone) {
  return normalizeLogoTone(logoTone) === LOGO_TONE.LIGHT;
}

export function logoPreviewSurfaceClass(logoTone, modoOscuro) {
  if (preferDarkLogoFrame(logoTone)) {
    return modoOscuro ? 'border-[#1F80FF]/40 bg-[#00357A]' : 'border-[#004AAD]/30 bg-[#00357A]';
  }
  return modoOscuro ? 'border-gray-600 bg-gray-900' : 'border-gray-200 bg-white';
}
